import React from "react";
import axios from 'axios';
import { connect } from "react-redux";
import Header from "../HeaderComponent/Header";

import history from "../../auth/history";
import Footer from './../FooterComponent/FooterComponet';
import moment from "moment";
import BenefisciarySubDetails from "./BenefisciarySubDetails";
import { v4 as uuidv4 } from 'uuid';
import { store } from "../../redux/store";
import { setSendersListDetails, selectedSender, setBeneMoneyTransfer, selectedBeneList, setSelectedBankName, setIfscCode, setBranchAddress, setSelectedBankId } from './../../redux/misc-data/misc-data.action';
import HeaderCommon from './../HeaderComponent/HeadeCommon';
import Menu from "../MenuComponent/Menu";
import tokenErrorHandler from "../tokenErrorHandler";
import { Link } from "react-router-dom";

const httpClient = axios.create();




class AccountDetails extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			phoneNo: this.props.phone,
			password: '',
			otpRef: '',
			message: '',
			errorMessage: ''
		}
	}





	componentDidMount() {



	}
	componentWillUnmount() {
	}

	print = (event) => {
		event.preventDefault();
		window.print();
	}

	errorMessageCall = (error) => {
		this.setState({
			errorMessage: error
		})
	}

	addBeneficiary = (event) => {
		store.dispatch(setSelectedBankName(''));
		store.dispatch(setIfscCode(''));
		store.dispatch(setBranchAddress(''));
		store.dispatch(setSelectedBankId(''));
		var addBeneficiaryBtn = document.getElementById('addBeneficiaryBtn');
		setTimeout(() => {
			addBeneficiaryBtn.click();
		}, 100);
	}

	render() {

		return (

			<div>
				<HeaderCommon />
				<Menu />
				<div class="main">


					<div class="right-side">
						<div class="container-fluid">



							<div class="row">
								<div class="col-12">
									<div class="card-b" id="rightdiv">
										<div id="recenttxn">
											<div class="head">
												<h3>Beneficiary Details</h3>
												<div class="headbtn">
													<button class="dbbtn" onClick={this.addBeneficiary} type="button">Back</button>
												</div>
												<Link to='/add-account'>
													<button id='addBeneficiaryBtn' hidden={true}></button>
												</Link>
											
											</div>

											<div class="status">
												<h3 class="success">Beneficiary has been added and verified successfully!</h3>
											</div>

											<BenefisciarySubDetails senderMobileShown={true}/>


											<div class="dashform">
												<button type="button" class="btn btn-primary" onClick={this.moneyTransfer}>Money Transfer</button>
											</div>
											{this.state.errorMessage != '' &&
												<div class='valid-error'>
													{this.state.errorMessage}</div>}
										</div>


									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<Footer />
			</div>
		);
	}
}


const mapStateToProps = (
	{ errorMessageReduce: { errorMessage, loginErrorMessage },
		miscReduce: { phone, selectSender, agentInfo,clientRole, token, benefisciaryRequest,
			callBackUrl } }
) => ({
	errorMessage, loginErrorMessage, phone, selectSender, agentInfo,clientRole, token, 
	benefisciaryRequest,callBackUrl
});

export default connect(mapStateToProps, null)(AccountDetails);
